<div class="header">
  <h2 mat-dialog-title>{{ data.title }}</h2>
</div>
<div class="font-16" mat-dialog-content>
  {{ data.message }}
</div>
<div class="font-16" mat-dialog-content>
  <div>MADB Incident</div>
  <div>{{ form.get('mission')?.value ? 'Mission' : '' }}</div>
  <div>{{ form.get('mode')?.value ? 'Mode' : '' }}</div>
  <div>{{ form.get('toArea')?.value ? 'To Area' : '' }}</div>
  <div>{{ form.get('yardsDrift')?.value !== null ? 'Yards of Drift' : '' }}</div>
  <div>Aircraft</div>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">Confirm</button>
</div>
